export function PMT(rate, nper, pv, fv = 0, type = 0) {
    if (rate === 0) {
        return -(pv + fv) / nper;
    }

    const pmt = -pv * rate / (1 - Math.pow(1 + rate, -nper));
    if (type === 1) {
        return pmt / (1 + rate);
    }
    return pmt;
}

export function formatCurrency(value) {
    return '$' + value.toLocaleString();
}
